module.exports = __webpack_public_path__ + "img/semantic-properties.ef3b2870.png";